import Remote from '@/util/Remote';

class Service {
  getMcmShopList(params) {
    return Remote.get('/activityDic/merchantShopList.do', params);
  }
}

export default new Service();
